export default __webpack_public_path__ + "static/media/declaration-signed.2b0b0fbb.png";